module.exports = __webpack_public_path__ + "assets/img/theX-content-12.03841ece.png";